import { Phone, MapPin, Mail, Star } from "lucide-react";
import logo from "../../assets/logo.png";

export const Footer = () => (
  <footer className="bg-fr-black border-t border-white/10 pt-24 pb-12" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-16 items-start">
        <div>
          <h2 className="font-display font-bold text-6xl sm:text-8xl tracking-tighter leading-[0.85]">
            {"LET'S"}<br /><span className="text-fr-blue-light">TALK.</span>
          </h2>
          <a href="#estimate" data-testid="footer-estimate-btn" className="btn-primary inline-flex mt-8">
            Get a Free Estimate
          </a>
        </div>

        <div className="grid sm:grid-cols-2 gap-10 lg:pt-4">
          <div>
            <span className="fr-mono text-xs tracking-[0.3em] uppercase text-white/40">Contact</span>
            <div className="mt-5 space-y-4">
              <a href="tel:8432975559" data-testid="footer-call-btn" className="flex items-center gap-3 text-white hover:text-fr-blue-light transition-colors">
                <Phone size={17} className="text-fr-blue-light" /> 843-297-5559
              </a>
              <div className="flex items-center gap-3 text-white/70">
                <MapPin size={17} className="text-fr-blue-light" /> All of Charleston, SC
              </div>
              <div className="flex items-center gap-3 text-white/70">
                <Mail size={17} className="text-fr-blue-light" /> Call or text for fastest response
              </div>
              <a href="https://g.page/r/CdvuvNufqQahEBM/review" target="_blank" rel="noopener noreferrer" data-testid="footer-review-btn" className="inline-flex items-center gap-3 text-white hover:text-fr-blue-light transition-colors">
                <Star size={17} className="text-fr-blue-light" /> Leave us a Google review
              </a>
            </div>
          </div>
          <div>
            <span className="fr-mono text-xs tracking-[0.3em] uppercase text-white/40">Services</span>
            <ul className="mt-5 space-y-2 text-white/70 text-sm">
              <li>Whole House Soft Wash</li>
              <li>Driveway & Walkway</li>
              <li>Roof & Gutter Cleaning</li>
              <li>Front Porch Painting</li>
              <li>Deck Staining</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src={logo} alt="First Response Exterior Cleaning LLC" className="h-12 w-auto" />
          <p className="fr-mono text-xs tracking-wider text-white/40">
            © {new Date().getFullYear()} First Response Exterior Cleaning LLC
          </p>
        </div>
        <p className="fr-mono text-xs tracking-wider text-white/40 italic">
          {"\"We clean it like we're responding to our own home.\""}
        </p>
      </div>
    </div>
  </footer>
);
